import { debugLog } from './debugLog';

/**
 * Test Embedded Checkout Utility
 * 
 * Utility functions to test and verify embedded checkout functionality
 */

export const testEmbeddedCheckout = () => {
  debugLog('=== EMBEDDED CHECKOUT TEST ===');
  
  // Check if Shopify Web Components are loaded
  const webComponentsLoaded = typeof customElements !== 'undefined' && 
    typeof window !== 'undefined' && 
    'customElements' in window;
  
  debugLog('Web Components supported:', webComponentsLoaded);
  
  // Check if shopify-store element exists
  const shopifyStore = document.querySelector('shopify-store');
  debugLog('Shopify Store element found:', !!shopifyStore);
  
  // Check if shopify-cart element exists
  const shopifyCart = document.querySelector('shopify-cart');
  debugLog('Shopify Cart element found:', !!shopifyCart);
  
  // Check if the script is loaded
  const scriptElement = document.querySelector('script[src*="web-components.js"]');
  debugLog('Web Components script loaded:', !!scriptElement);
  
  // Test custom elements registry
  if (webComponentsLoaded) {
    const shopifyStoreRegistered = customElements.get('shopify-store');
    const shopifyCartRegistered = customElements.get('shopify-cart');
    
    debugLog('shopify-store registered:', !!shopifyStoreRegistered);
    debugLog('shopify-cart registered:', !!shopifyCartRegistered);
  }
  
  debugLog('=== END EMBEDDED CHECKOUT TEST ===');
  
  return {
    webComponentsLoaded,
    shopifyStoreElement: !!shopifyStore,
    shopifyCartElement: !!shopifyCart,
    scriptLoaded: !!scriptElement,
    allGood: webComponentsLoaded && shopifyStore && shopifyCart && scriptElement
  };
};

declare global {
  interface Window {
    testEmbeddedCheckout?: typeof testEmbeddedCheckout;
  }
}

// Make available globally for testing
if (typeof window !== 'undefined') {
  window.testEmbeddedCheckout = testEmbeddedCheckout;
}
